/**
 * websiteCheckout — the course editor's preview of what the public website
 * will offer once "Take payments on your website" is on.
 *
 * Twin of vc_be utils/websiteCheckoutRules (planCourseFeeSettings for the
 * checks, quoteCourse for the options). The server prices every order itself;
 * this only lets the admin see the same answer before saving — change both.
 */
import { parseFeeText, readMoney } from "./enrolmentFee";

const round2 = (n) => Math.round(n * 100) / 100;

/**
 * @param {{ fees: string|number, registrationFee: { enabled, amount, includedInFee } }} input
 * @returns {{ error: string, field: string }
 *          | { fee: number|null, registration: number, included: boolean, total: number|null,
 *              options: Array<{ key: 'full'|'registration', amount: number, balance: number }> }}
 */
export function previewCoursePayments({ fees, registrationFee } = {}) {
  const fee = parseFeeText(fees);
  const reg = registrationFee || {};
  const on = reg.enabled === true;
  const typed = readMoney(reg.amount);
  const amount = typed === null ? 0 : typed;
  const included = reg.includedInFee !== false;

  if (on) {
    if (!Number.isFinite(amount) || amount <= 0) {
      return { error: "Enter the registration fee — an amount above ₹0.", field: "registrationFee.amount" };
    }
    if (Math.abs(round2(amount) - amount) > 1e-9) {
      return { error: "The registration fee can have at most two decimals.", field: "registrationFee.amount" };
    }
    if (fee === null || fee <= 0) {
      return { error: "Enter the course fee before adding a registration fee.", field: "fees" };
    }
    if (included && amount >= fee) {
      return { error: "The registration fee is part of the course fee, so it must be less than it.", field: "registrationFee.amount" };
    }
  }

  if (fee === null || fee < 1) return { fee, registration: 0, included, total: null, options: [] };
  const registration = on ? round2(amount) : 0;
  const total = round2(fee + (on && !included ? registration : 0));
  const options = [{ key: "full", amount: total, balance: 0 }];
  if (on && registration >= 1 && registration < total) {
    options.push({ key: "registration", amount: registration, balance: round2(total - registration) });
  }
  return { fee: round2(fee), registration, included, total, options };
}
